import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[var(--bg-card)] border-t border-[var(--border-light)] py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Logo Section */}
        <div className="mb-8 flex items-center gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_smart-site-intel/artifacts/iqxongg8_Logo%20-%20Fern%20Tree.png" 
            alt="Ferntree Logo" 
            className="h-10 w-auto"
          />
          <span className="text-2xl font-bold text-[var(--text-primary)] tracking-tight" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>Ferntree</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company */}
          <div>
            <h3 className="font-semibold text-[var(--text-primary)] mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="font-semibold text-[var(--text-primary)] mb-4">Solutions</h3>
            <ul className="space-y-2">
              <li><Link to="/solutions/security" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Security & Surveillance</Link></li>
              <li><Link to="/solutions/industry-4" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Industry 4.0</Link></li>
              <li><Link to="/solutions/agriculture" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Agriculture</Link></li>
              <li><Link to="/solutions/healthcare" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Healthcare (WIP)</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-[var(--text-primary)] mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Services Overview</Link></li>
              <li><Link to="/platform" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Platform</Link></li>
              <li><Link to="/industries" className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-primary)] transition-colors">Industries</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-[var(--text-primary)] mb-4">Contact</h3>
            <p className="text-sm text-[var(--text-secondary)] mb-2">Sydney, Australia</p>
            <a href="mailto:hello@ferntree.io" className="text-sm text-[var(--accent-primary)] hover:underline">hello@ferntree.io</a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[var(--border-light)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[var(--text-muted)]">
            © {new Date().getFullYear()} Ferntree. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-[var(--text-muted)] hover:text-[var(--accent-primary)] transition-colors">Privacy Policy</a>
            <a href="#" className="text-sm text-[var(--text-muted)] hover:text-[var(--accent-primary)] transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;